import Api from "../Api";

class Redirection extends Api {
  public async getUrl(
    code: string,
    q?: string,
    s?: string,
    m?: string
  ): Promise<string | undefined> {
    let searchParams = [];
    if (q) searchParams.push(`q=${q}`);
    if (s) searchParams.push(`s=${s}`);
    if (m) searchParams.push(`m=${m}`);

    const result = await this._axiosInstance.get<{url: string}>(
      `/${code}${searchParams.length > 0 ? "?" + searchParams.join("&") : ""}`
    );
    if (result.status === 200) {
      return result.data.url;
    } else {
      return undefined;
    }
  }
}

export default new Redirection();
